<template>
  <div
    v-if="isLoadingTasks"
    key="loadingTasks"
    class="m-edition-map-chart-node-task"
  >
    <p class="font-size-small text-align-center">Cargando Tareas...</p>
  </div>
  <div
    v-else-if="nodo.tarea && nodo.tarea.diaEntrega"
    key="loadedTasks"
    class="m-edition-map-chart-node-task"
  >
    <p
      v-if="this.$store.getters.getSelectedMapNode.tarea.diaEntrega"
      key="limitDate"
      class="display-flex-column font-size-small text-align-center"
    >
      <span
        v-if="nodo.tarea.cumplido"
        class="margin-top-medium"
      >
        Si entregas tu tarea antes del
        {{ $moment.parseZone(nodo.fecha_activo)
          .add(parseInt(nodo.tarea.diaEntrega), 'days')
          .format('DD/MM/YYYY') }}
        puedes obtener {{ nodo.tarea.cumplido }}
        <i class="fas fa-star font-size-xsmall text-color-notifications-primary"></i>
      </span>
      <span
        v-if="nodo.tarea.noCumplido"
        class="margin-bottom-medium margin-top-medium"
      >
        Si entregas tu tarea luego del
        {{ $moment.parseZone(nodo.fecha_activo)
          .add(parseInt(nodo.tarea.diaEntrega), 'days')
          .format('DD/MM/YYYY') }}
        puedes obtener {{ nodo.tarea.noCumplido }}
        <i class="fas fa-star font-size-xsmall text-color-notifications-primary"></i>
      </span>
    </p>

    <div
      v-if="tasks.length"
      class="m-edition-map-chart-node-task-list"
    >
      <transition-group
        name="a-transtion-slide"
        tag="ul"
      >
        <li
          v-for="task in tasks"
          :key="task.id"
        >
          <a
            :class="visibleTask === task.id ? 'selected-task' : ''"
            @click.prevent="showTask(task)"
          >
            <span class="task-date">
              <span :class="`task-date-state task-date-state-${states[task.estado.estado].class}`">
                <i :class="[states[task.estado.estado].icon, 'task-date-icon']"></i>
                {{ states[task.estado.estado].name }}
              </span>
              <span class="task-date-day">
                {{ $moment.parseZone(task.fecha_alta).format('DD/MM/YYYY') }}
              </span>
            </span>
            <span class="task-metrics">
              <span class="messages">
                {{ task.mensajes.length }}
                <i class="fas fa-comments"></i>
              </span>
              <a
                v-if="task.estado.estado === 0"
                class="delete"
                href="#"
                @click.prevent="$modal.showModal('MoleculeEditionMapChartNodeTaskModalDelete', nodo)"
              >
                <span
                  class="a-tooltip-primary a-tooltip-bottom"
                  data-tooltip-text="Eliminar"
                >
                  <i class="far fa-trash-alt"></i>
                </span>
              </a>
              <span
                v-else
                class="points"
              >
                {{ task.puntaje }}
                <i class="fas fa-star"></i>
              </span>
            </span>
          </a>
          <!-- <span>{{nodo}}</span> -->
          <div
            v-if="visibleTask === task.id"
            class="task-content"
          >
            <MoleculeContentNode :is-task="true"/>
            <div class="m-edition-map-chart-node-task-messages">
              <div
                v-if="showLoadingState"
                class="font-size-small margin-bottom-medium text-align-center"
              >
                Cargando mensajes...
              </div>
              <div
                v-for="mensaje in messages"
                :key="mensaje.id"
                class="task-record-message"
              >
                <span class="task-record-message-avatar">
                  <img
                    class="a-avatar-primary"
                    :src="mensaje.avatar"
                  />
                </span>
                <span class="task-record-message-text">
                  <span class="task-record-message-text-name">
                    {{ mensaje.razon_social }}
                  </span>
                  <span>
                    {{ mensaje.mensaje }}
                  </span>
                </span>
              </div>
              <div class="task-record-write-message">
                <span class="task-record-write-message-avatar">
                  <img
                    class="a-avatar-primary"
                    :src="userAvatar"
                  />
                </span>
                <div class="task-record-write-message-text">
                  <form
                    autocomplete="off"
                    @submit.prevent="false"
                  >
                    <AtomTextAreaPrimary
                      v-model="messageData.tarea_mensaje.mensaje"
                      :disabled="sendingMessage"
                      maxlength="255"
                      placeholder="Escribe aquí un mensaje"
                    />
                    <div class="message-text-actions">
                      <a
                        class="send-message"
                        href="#"
                        @click.prevent="createInscripcionNodoActivoTareaMensaje(task.id)"
                      >
                        <i :class="sendingMessage
                          ? 'fas fa-spinner fa-spin'
                          : 'far fa-location-arrow'"
                        >
                        </i> Enviar
                      </a>
                      <span class="message-text-length">
                        {{ messageData.tarea_mensaje.mensaje.length }} / 255
                      </span>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </li>
      </transition-group>
    </div>

    <MoleculeContentEditor
      v-if="!isLoadingTasks && previousNode.visto && (tasks.length === 0 ||
        tasks[this.tasks.length - 1].estado.estado === 2 ||
        tasks[this.tasks.length - 1].estado.estado === 3) && canEditTask"
      class="margin-bottom-small"
      @readInscripcionNodoActivoTareas="readInscripcionNodoActivoTareas(true)"
    />

    <div v-if="tasks.length === 0 ||
      tasks[this.tasks.length - 1].estado.estado === 2 ||
      tasks[this.tasks.length - 1].estado.estado === 3"
    >
      <a
        v-if="!isLoadingTasks && !canEditTask"
        class="cant-edit-task-message"
        @click.prevent="$store.commit('setSelectedMapNode', pendingNodeTask)"
      >
        {{ ` Para entregar esta tarea primero debes aprobar la tarea del paso
          ${pendingNodeTask.camino_alfanumerico}${pendingNodeTask.alfanumerico}` }}
      </a>
    </div>
  </div>
  <div
    v-else
    key="zeroTask"
    class="m-edition-map-chart-node-task"
  >
    <p class="font-size-xsmall margin-top-xlarge text-align-center">
      No hay tarea asignada para este paso.
    </p>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionMapChartNodeTask',

  components: {
    MoleculeContentEditor: () => import('@/components/molecules/MoleculeContentEditor'),
    MoleculeContentNode: () => import('@/components/molecules/MoleculeContentNode')
    // MoleculeEditionMapChartNodeTaskMessages: () => import('@/components/molecules/MoleculeEditionMapChartNodeTaskMessages')
  },

  data () {
    return {
      isLoadingTasks: true,
      messages: [],

      messageData: {
        academia: '',
        nodo: '',

        tarea_mensaje: {
          mensaje: '',
          nodo_activo_tarea: 0
        }
      },

      nodosNavegacion: [],
      pendingNodeTask: {},
      sendingMessage: false,
      showEditor: false,
      showLoadingState: true,

      states: [
        {
          icon: 'fas fa-file-exclamation',
          class: 'in-review',
          name: 'En Revisión'
        },
        {
          icon: 'fas fa-file-check',
          class: 'approved',
          name: 'Aprobada'
        },
        {
          icon: 'fas fa-file-times',
          class: 'rejected',
          name: 'Rechazada'
        },
        {
          icon: 'fas fa-file-archive',
          class: 'deleted',
          name: 'Eliminada'
        }
      ],

      tasks: [],
      userAvatar: '@/assets/img/avatar.png',
      visibleTask: ''
    }
  },

  computed: {
    canEditTask () {
      let currentNodeTaskIndex = this.nodosNavegacion.findIndex(nodo => nodo.id === this.$store.getters.getSelectedMapNode.id)
      let pendingNodeTaskIndex = this.nodosNavegacion.findIndex(nodo => nodo.tarea && nodo.tarea.diaEntrega &&
        (nodo.tareas_alumno.length === 0 || (nodo.tareas_alumno[nodo.tareas_alumno.length - 1].estado.estado === 0 ||
        nodo.tareas_alumno[nodo.tareas_alumno.length - 1].estado.estado === 2 ||
        nodo.tareas_alumno[nodo.tareas_alumno.length - 1].estado.estado === 3)))
      return pendingNodeTaskIndex === currentNodeTaskIndex
    },

    nodo () {
      return this.$store.getters.getSelectedMapNode
    },

    nodoId () {
      return this.$store.getters.getSelectedMapNode.id
    },

    nodosActivosNavegacion () {
      return this.$store.getters.getMapNodesEnrollmentNavigation
    },

    previousNode () {
      let currentNodeIndex = this.nodosNavegacion.findIndex(nodo => nodo.id === this.$store.getters.getSelectedMapNode.id)
      return this.nodosNavegacion[currentNodeIndex - 1]
    },

    updatedData () {
      return this.$modal.updatedData
    }
  },

  watch: {
    nodoId () {
      this.isLoadingTasks = true
      this.tasks = []
      this.visibleTask = ''
      this.setPendingNodeTask()
      this.readInscripcionNodoActivoTareas()
    },

    updatedData () {
      if (this.$modal.methodToRun === 'readInscripcionNodoActivoTareas') {
        this.readInscripcionNodoActivoTareas()
      }
    }
  },

  created () {
    this.userAvatar = this.$store.getters.getUserData.vidroop_data
      ? this.$store.getters.getUserData.vidroop_data.avatar
      : this.$store.getters.getUserData.picture
        ? this.$store.getters.getUserData.picture
        : '@/assets/img/avatar.png'
    this.readInscripcionNodoActivoTareas()
    this.getNodosNavegacion()
    this.setPendingNodeTask()
  },

  methods: {

    createInscripcionNodoActivoTareaMensaje (idTarea) {
      if (!this.sendingMessage && this.messageData.tarea_mensaje.mensaje !== '') {
        this.sendingMessage = true
        this.messageData = {
          academia: this.$store.getters.getAcademyData.id,
          nodo: this.$store.getters.getSelectedMapNode.id,

          tarea_mensaje: {
            mensaje: this.messageData.tarea_mensaje.mensaje,
            nodo_activo_tarea: idTarea
          }
        }

        this.$services.create('inscripcion', 'createInscripcionNodoActivoTareaMensaje', this.messageData,
          [this.$store.getters.getSelectedMap.id_inscripcion])
          .then(response => {
            console.log(response.data)
            this.messageData.tarea_mensaje.mensaje = ''
            this.readInscripcionNodoActivoTareaMensajes(idTarea)
            // this.$alerts.pushAlert('mEditionAcademyData', 'updateAcademiaDatosPersona', 'success')
            this.sendingMessage = false
          })
          .catch(error => {
            console.log(error)
            // this.$alerts.pushAlert('mEditionAcademyData', 'updateAcademiaDatosPersona', 'error', 'a-alert-danger')
            this.sendingMessage = false
          })
      }
    },

    getNodosNavegacion () {
      this.nodosNavegacion = []
      this.nodosNavegacion = this.nodosActivosNavegacion.length > 0
        ? [...this.nodosActivosNavegacion]
        : []
    },

    readInscripcionNodoActivoTareaMensajes (idTarea) {
      this.showLoadingState = true

      let endpointFilter = {
        academia: this.$store.getters.getAcademyData.id,
        nodo: this.$store.getters.getSelectedMapNode.id,
        nodo_activo_tarea: idTarea
      }

      this.$services.read('inscripcion', 'readInscripcionNodoActivoTareaMensajes', {},
        [this.$store.getters.getSelectedMap.id_inscripcion], endpointFilter)
        .then(response => {
          this.messages = [...response.data.mensajes]
          this.showLoadingState = false
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState = false
        })
    },

    readInscripcionNodoActivoTareas (loadNodos = false) {
      this.isLoadingTasks = true
      this.$services.read('inscripcion', 'readInscripcionNodoActivoTareas', {},
        [this.$store.getters.getSelectedMap.id_inscripcion],
        { academia: this.$store.getters.getAcademyData.id,
          nodo: this.$store.getters.getSelectedMapNode.id })
        .then(response => {
          if (loadNodos) {
            this.$modal.updateData('readInscripcionNodos')
          }
          this.tasks = [...response.data]
          this.isLoadingTasks = false
        })
        .catch(error => {
          console.log(error)
          this.isLoadingTasks = false
        })
    },

    resetMessageData () {
      this.messageData = {
        academia: '',
        nodo: '',

        tarea_mensaje: {
          mensaje: '',
          nodo_activo_tarea: 0
        }
      }
    },

    setPendingNodeTask () {
      this.pendingNodeTask = this.nodosNavegacion.find(nodo => nodo.tarea && nodo.tarea.diaEntrega &&
        (nodo.tareas_alumno.length === 0 || (nodo.tareas_alumno[nodo.tareas_alumno.length - 1].estado.estado === 0 ||
        nodo.tareas_alumno[nodo.tareas_alumno.length - 1].estado.estado === 2 ||
        nodo.tareas_alumno[nodo.tareas_alumno.length - 1].estado.estado === 3)))
    },

    showTask (task) {
      if (this.visibleTask === task.id) {
        this.visibleTask = ''
        this.messages = []
        this.resetMessageData()
        this.$store.commit('setSelectedMapNodeTask', {})
      } else {
        this.messages = []
        this.resetMessageData()
        this.visibleTask = task.id
        this.$store.commit('setSelectedMapNodeTask', Object.assign({}, task))
        this.readInscripcionNodoActivoTareaMensajes(task.id)
      }
    }
  }
}
</script>
